<template>
  <div>
<!--    <div
      v-show="isAdministrator && !queryList.store_id"
      class="loading-box"
    >
      <el-form
        class="loading-form"
        label-position="left"
        label-width="80px"
      >
        <el-form-item label="所属门店">
          <v-select-store v-model="queryList.store_id" @change="handleStoreChange"/>
        </el-form-item>
      </el-form>
    </div>-->
    <div
      v-show="isShowDatePicker"
      class="loading-box"
    >
      <el-form
        class="loading-form"
        label-position="left"
        label-width="80px"
      >
        <el-form-item label="所属月份">
          <el-date-picker
            v-model="queryList.date"
            :picker-options="pickerOptions"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择所属月份"
            @change="handleDateChange"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="rank-container">
      <el-tabs v-model="currentStoreId">
        <el-tab-pane v-for="store in stores" :key="store.id" :label="store.store_name" :name="`${store.id}`">
          <template v-if="ranks[currentStoreId]">
            <img class="rank-background" src="https://img.jiahewushe.com/icon/rank-background.png" alt="background">
            <div class="date" @click="handleDateClick">{{ ranks[currentStoreId].date }}</div>
            <div class="tip">
              内部数据，不要对外泄露。除专业班外，对全国门店的数据进行对比分析，绿色数据代表在全国门店中位线以上，红色数据代表在中位线以下，需要及时关注和调整
            </div>
            <div class="relative store-cover-box">
              <img class="store-cover" :src="store.cover" alt="">
              <div class="absolute flex manager-avatar-box">
                <v-avatar class="manager-avatar" :value="ranks[currentStoreId].manager_avatar" :is-show-shadow="true"/>
                <div v-if="ranks[currentStoreId].managers" class="manager-name ellipsis">{{ store.store_name  }}店 / 店长{{ ranks[currentStoreId].managers.join('、') }}</div>
              </div>
            </div>

            <div class="rank-title">
              <div class="title-border"></div>
              课程
            </div>
            <div class="rank-item flex-justify-between">
              <span>课消收入 {{ ranks[currentStoreId].course_consumption | toYuan }}</span>
              <span :class="`rank-number ${getColor('course_consumption_rank')}-color`">
                NO.{{ ranks[currentStoreId].course_consumption_rank }}
              </span>
            </div>
            <div class="rank-item flex-justify-between">
              <span>成本支出 {{ ranks[currentStoreId].expenditure | toYuan }}</span>
              <span :class="`rank-number ${getColor('expenditure_rank', true)}-color`">
                NO.{{ ranks[currentStoreId].expenditure_rank }}
              </span>
            </div>
            <div class="rank-item flex-justify-between">
              <span>课消利润 {{ ranks[currentStoreId].course_consumption_profit | toYuan }}</span>
              <span :class="`rank-number ${getColor('course_consumption_profit_rank')}-color`">
                NO.{{ ranks[currentStoreId].course_consumption_profit_rank }}
              </span>
            </div>
            <div class="rank-item flex-justify-between">
              <span>平均大课人数 {{ ranks[currentStoreId].average_attendance }} 人/节</span>
              <span :class="`rank-number ${getColor('average_attendance_rank')}-color`">
                NO.{{ ranks[currentStoreId].average_attendance_rank }}
              </span>
            </div>
            <div class="rank-item flex-justify-between">
              <span>课程稳定性 {{ ranks[currentStoreId].course_full_rate | toYuan }}  %</span>
              <span :class="`rank-number ${getColor('course_full_rate_rank')}-color`">
                NO.{{ ranks[currentStoreId].course_full_rate_rank }}
              </span>
            </div>

            <div class="rank-item flex-justify-between">
              <span>试课 {{ ranks[currentStoreId].trial_count }} 次</span>
              <span :class="`rank-number ${getColor('trial_count_rank')}-color`">
                NO.{{ ranks[currentStoreId].trial_count_rank }}
              </span>
            </div>

            <div class="rank-item flex-justify-between">
              <span>试课 {{ ranks[currentStoreId].trial_student_count }} 人</span>
              <span :class="`rank-number ${getColor('trial_student_count_rank')}-color`">
                NO.{{ ranks[currentStoreId].trial_student_count_rank }}
              </span>
            </div>

            <div class="rank-item flex-justify-between">
              <span>试课报名 {{ ranks[currentStoreId].trial_enroll_count }} 人</span>
              <span :class="`rank-number ${getColor('trial_enroll_count_rank')}-color`">
                NO.{{ ranks[currentStoreId].trial_enroll_count_rank }}
              </span>
            </div>

            <div class="rank-item flex-justify-between">
              <span>试课报名占比 {{ ranks[currentStoreId].trial_enroll_rate | toYuan }}  %</span>
              <span :class="`rank-number ${getColor('trial_enroll_rate_rank')}-color`">
                NO.{{ ranks[currentStoreId].trial_enroll_rate_rank }}
              </span>
            </div>

            <div class="rank-title">
              <div class="title-border"></div>
              财务
            </div>
            <div class="rank-item flex-justify-between">
              <span>预付款新增 {{ ranks[currentStoreId].all_income | toYuan }}</span>
              <span :class="`rank-number ${getColor('all_income_rank')}-color`">
                NO.{{ ranks[currentStoreId].all_income_rank }}
              </span>
            </div>
            <div class="rank-item flex-justify-between">
              <span>成本支出 {{ ranks[currentStoreId].expenditure | toYuan }}</span>
              <span :class="`rank-number ${getColor('expenditure_rank', true)}-color`">
                NO.{{ ranks[currentStoreId].expenditure_rank }}
              </span>
            </div>
            <div class="rank-item flex-justify-between">
              <span>现金流入 {{ ranks[currentStoreId].profit | toYuan }}</span>
              <span :class="`rank-number ${getColor('profit_rank')}-color`">
                NO.{{ ranks[currentStoreId].profit_rank }}
              </span>
            </div>
            <div class="rank-item flex-justify-between">
              <span>未消预付款 {{ ranks[currentStoreId].not_consumed_amount | toYuan }}</span>
              <span :class="`rank-number ${getColor('not_consumed_amount_rank', true)}-color`">
                NO.{{ ranks[currentStoreId].not_consumed_amount_rank }}
              </span>
            </div>

            <div class="rank-item flex-justify-between">
              <span>未开卡 {{ ranks[currentStoreId].not_start_card_count }} 张</span>
              <span :class="`rank-number ${getColor('not_start_card_count_rank', true)}-color`">
                NO.{{ ranks[currentStoreId].not_start_card_count_rank }}
              </span>
            </div>

            <div class="rank-item flex-justify-between">
              <span>未开卡金额 {{ ranks[currentStoreId].not_start_card_amount | toYuan }}</span>
              <span :class="`rank-number ${getColor('not_start_card_amount_rank', true)}-color`">
                NO.{{ ranks[currentStoreId].not_start_card_amount_rank }}
              </span>
            </div>

            <div class="rank-title">
              <div class="title-border"></div>
              老师
            </div>
            <div v-for="(teacher, k) in ranks[currentStoreId].teachers" :key="teacher.id || k" class="rank-item flex-align-center">
              {{ k + 1 }}.
              <v-avatar class="teacher-avatar" :value="teacher.avatar"/>
              <div class="teacher-name ellipsis">{{ teacher.nickname }}</div>
              <div>
                平均人数 {{ (+teacher.avg_students).toFixed(2) }} 人，
                <span v-if="teacher.leave_count" class="danger-color bold">旷课 {{ teacher.leave_count }} 节</span>
                <span v-else class="success-color bold">全勤</span>
              </div>
            </div>
          </template>
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { mapGetters } from 'vuex';
  import { getLegalQueryList } from "@/utils/formats";
  import { getRanks } from "@/api/monthly-report";
  import { getStoresOfManager } from '@/api/administratorRoleMerge';
  import { defaultAvatar } from "@/filters"

  const initData = {
    date: '',
    report_count: 0,
    course_consumption: 0,
    course_consumption_rank: 0,
    expenditure: 0,
    expenditure_rank: 0,
    course_consumption_profit: 0,
    course_consumption_profit_rank: 0,
    average_attendance: 0,
    average_attendance_rank: 0,
    trial_count: 0,
    trial_count_rank: 0,
    course_full_rate: 0,
    course_full_rate_rank: 0,
    trial_student_count: 0,
    trial_student_count_rank: 0,
    trial_enroll_count: 0,
    trial_enroll_count_rank: 0,
    trial_enroll_rate: 0,
    trial_enroll_rate_rank: 0,
    not_consumed_amount: 0,
    not_consumed_amount_rank: 0,
    not_start_card_count: 0,
    not_start_card_count_rank: 0,
    not_start_card_amount: 0,
    not_start_card_amount_rank: 0,
    all_income: 0,
    all_income_rank: 0,
    profit: 0,
    profit_rank: 0,
    managers: [],
    teachers: [],
    manager_avatar: '',
  };
  export default {
    name: RouteConfig.monthlyReportRankList.name,
    data: () => ({
      count: 0,
      list: [],
      rank: JSON.parse(JSON.stringify(initData)),
      ranks: {},
      stores: [],
      currentStoreId: '',
      queryList: {
        store_id: 0,
        date: '',
      },
      currentDate: '',
      isShowDatePicker: false,
      pickerOptions: {
        disabledDate: (time) => time.getTime() >= Date.now(),
      },
      isLoading: false,
      isLoadingStore: false,
      defaultAvatar,
    }),
    watch: {
      'queryList.store_id'(id) {
        if (this.currentStoreId === `${id}`) return;
        this.currentStoreId = `${id}`;
      },
      currentStoreId(id) {
        if (this.queryList.store_id === +id || 0) return;
        this.queryList.store_id = +id || 0;
        this.load();
      },
    },
    computed: {
      ...mapGetters([
        'isAdministrator',
        'isManager',
        'isReceptionist',
        'defaultStoreId',
        'userAvatar',
        'userNickname',
      ]),
    },
    methods: {
      getColor(key, isAsc = false) {
        const rank = this.ranks[this.currentStoreId];
        const midCount = rank.report_count / 2;
        const isDanger = isAsc ? rank[key] < midCount : rank[key] > midCount;
        return isDanger ? 'danger' : 'success';
      },
      async load(route = this.$route, next) {
        if (this.isLoading) return;

        const { queryList } = this;
        const { query } = route;
        getLegalQueryList(queryList, query);

        if (!queryList.store_id) {
          if (next) next();
          return;
        }

        this.isLoading = true;
        let { isError, data } = await getRanks(queryList);
        this.isLoading = false;

        if (next) next();
        if (isError) return;

        if (!data.date) data = JSON.parse(JSON.stringify(initData));
        if (queryList.date) data.date = queryList.date;
        this.$set(this.ranks, this.currentStoreId, data);
      },
      async getStores() {
        if (this.isLoadingStore) return;

        this.isLoadingStore = true;
        const { isError, data } = await getStoresOfManager();
        this.isLoadingStore = false;
        if (isError || !data.length) return;

        this.stores = data;
        if (!this.queryList.store_id) {
          this.queryList.store_id = data[0].id;
          this.load();
        }
      },
      handleDateClick() {
        this.isShowDatePicker = true;
      },
      handleDateChange() {
        this.isShowDatePicker = false;
        RouteConfig.monthlyReportRankList.push(this.queryList);
      },
    },
    beforeRouteUpdate(to, from, next) {
      this.load(to, next);
    },
    beforeMount() {
      this.getStores();
      this.queryList.store_id = this.defaultStoreId;
      this.load();
    },
  };
</script>

<style src="./rank-list.css" scoped/>

